import { useEffect, useState } from "react";

import API_URL from "../apiConfig";

import "../CSS/feedback.css";

import Seo from "../components/Seo";


function FeedbackPage() {

    const [name, setName] =
        useState("");

    const [text, setText] =
        useState("");

    const [feedbacks, setFeedbacks] =
        useState([]);

    const [meldung, setMeldung] =
        useState("");

    const [fehler, setFehler] =
        useState("");

    const [isSubmitting, setIsSubmitting] =
        useState(false);


    // ==================================================
    // FREIGEGEBENE FEEDBACKS LADEN
    // ==================================================

    function ladeFeedbacks() {

        fetch(
            `${API_URL}/feedback.php`
        )

            .then((response) => {

                if (!response.ok) {

                    throw new Error(
                        "Feedbacks konnten nicht geladen werden."
                    );
                }

                return response.json();
            })

            .then((daten) => {

                setFeedbacks(daten);
            })

            .catch((error) => {

                console.error(
                    "Fehler beim Laden der Feedbacks:",
                    error
                );
            });
    }


    // ==================================================
    // BEIM START LADEN
    // ==================================================

    useEffect(() => {

        ladeFeedbacks();

    }, []);


    // ==================================================
    // FORMULAR ZURÜCKSETZEN
    // ==================================================

    function handleReset() {

        setName("");
        setText("");
        setMeldung("");
        setFehler("");
    }


    // ==================================================
    // FEEDBACK ABSENDEN
    // ==================================================

    async function handleSubmit(event) {

        event.preventDefault();


        if (isSubmitting) {

            return;
        }


        setMeldung("");
        setFehler("");


        const bereinigterName =
            name.trim();

        const bereinigterText =
            text.trim();


        // ==================================================
        // EINGABEN PRÜFEN
        // ==================================================

        if (
            !bereinigterName ||
            !bereinigterText
        ) {

            setFehler(
                "Bitte Name und Feedback ausfüllen."
            );

            return;
        }


        // ==================================================
        // SPEICHERN
        // ==================================================

        try {

            setIsSubmitting(true);


            const response =
                await fetch(
                    `${API_URL}/feedback.php`,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type":
                                "application/json"
                        },

                        body: JSON.stringify({
                            name:
                                bereinigterName,

                            text:
                                bereinigterText
                        })
                    }
                );


            const daten =
                await response.json();


            if (!response.ok) {

                throw new Error(
                    daten.error ||
                    "Feedback konnte nicht gespeichert werden."
                );
            }


            // ==================================================
            // FORMULAR LEEREN
            // ==================================================

            setName("");
            setText("");


            // ==================================================
            // ERFOLGSMELDUNG
            // ==================================================

            setMeldung(
                daten.message
            );


            // ==================================================
            // FREIGEGEBENE FEEDBACKS NEU LADEN
            // ==================================================

            ladeFeedbacks();


        } catch (error) {

            setFehler(
                error.message
            );


        } finally {

            setIsSubmitting(false);
        }
    }


    // ==================================================
    // AUSGABE
    // ==================================================

    return (

        <>

            <Seo
                title="Feedback"
                description="Feedback und Rückmeldungen von Besuchern der persönlichen Webseite von Ivan Jörg."
                canonical="https://www.irj.ch/feedback"
            />


            <div className="intro">

                <p>
                    Ich freue mich über Dein persönliches Feedback
                    zu meiner Webseite.
                </p>

            </div>


            <main>

                <div className="feedback-container">

                    <form
                        className="feedback-formular"
                        onSubmit={handleSubmit}
                    >

                        <div className="formular-kopf">

                            <h2>
                                Dein Feedback
                            </h2>

                            <p>
                                Wenn Du Anregungen, Rückmeldungen oder
                                einen persönlichen Eindruck zu meiner
                                Webseite hast, kannst Du ihn hier gerne
                                hinterlassen.
                            </p>

                        </div>


                        <div className="formular-gruppe">

                            <label htmlFor="feedback-name">

                                Dein Name
                                <span className="pflichtzeichen">
                                    *
                                </span>

                            </label>

                            <input
                                id="feedback-name"
                                type="text"
                                value={name}
                                maxLength="80"
                                onChange={
                                    (event) =>
                                        setName(
                                            event.target.value
                                        )
                                }
                            />

                        </div>


                        <div className="formular-gruppe">

                            <label htmlFor="feedback-text">

                                Dein Feedback
                                <span className="pflichtzeichen">
                                    *
                                </span>

                            </label>

                            <textarea
                                id="feedback-text"
                                value={text}
                                rows="7"
                                maxLength="1500"
                                onChange={
                                    (event) =>
                                        setText(
                                            event.target.value
                                        )
                                }
                            />

                            <small>
                                Dein Beitrag wird erst nach meiner
                                Freigabe veröffentlicht.
                            </small>

                        </div>


                        <div className="formular-buttons">

                            <button
                                type="submit"
                                className="button button-absenden"
                                disabled={isSubmitting}
                            >
                                {
                                    isSubmitting
                                        ? "Wird gesendet..."
                                        : "Feedback absenden"
                                }
                            </button>


                            <button
                                type="button"
                                className="button button-abbrechen"
                                onClick={handleReset}
                            >
                                Abbrechen
                            </button>

                        </div>


                        {
                            meldung && (

                                <p>
                                    {meldung}
                                </p>

                            )
                        }


                        {
                            fehler && (

                                <p>
                                    {fehler}
                                </p>

                            )
                        }

                    </form>


                    <section>

                        <h2>
                            Das sagen Besucher
                        </h2>


                        {
                            feedbacks.length === 0 ? (

                                <p>
                                    Zurzeit sind noch keine Feedbacks
                                    veröffentlicht.
                                </p>

                            ) : (

                                <div>

                                    {
                                        feedbacks.map(
                                            (feedback) => (

                                                <article
                                                    key={feedback.id}
                                                >

                                                    <strong>
                                                        {feedback.name}
                                                    </strong>

                                                    <span>
                                                        {" "}
                                                        {feedback.datum}
                                                    </span>

                                                    <p>
                                                        {feedback.text}
                                                    </p>

                                                </article>

                                            )
                                        )
                                    }

                                </div>

                            )
                        }

                    </section>

                </div>

            </main>

        </>

    );
}


export default FeedbackPage;